import { SerializableObject } from '../../common-react/core';

export class OneTimePaymentResponse extends SerializableObject {
	paymentResponse?: PaymentResponse; // payment response object
	threeDSChallengeHtmlFormResponse?: ThreeDSChallengeHtmlFormResponse;
}

export class PaymentResponse extends SerializableObject {
	transactionId: string;
}

export class ThreeDSChallengeHtmlFormResponse extends SerializableObject {
	cardVerificationRawResponse: string;
}
